__turbopack_context__.v({
  "description": "StoryCard-module__Idy1Ra__description",
  "media": "StoryCard-module__Idy1Ra__media",
  "mediaWrapper": "StoryCard-module__Idy1Ra__mediaWrapper",
  "reverse": "StoryCard-module__Idy1Ra__reverse",
  "root": "StoryCard-module__Idy1Ra__root",
  "text": "StoryCard-module__Idy1Ra__text",
  "title": "StoryCard-module__Idy1Ra__title",
});
